import axios from 'axios'
const actions = {
    addArticleToInventory({commit}, data) {
        axios.post('api/setSingleInventory', data).then(() => {
            commit('addToTotalInventory', data.dataForStore)
            commit('addToPersonalInventory', data)
        })
    },

    addArticleToPersonalInventory({commit}, data) {
        axios.post('api/setSingleInventory', data).then(() => {
            commit('addToPersonalInventory', data)
        })
    },

    removeArticleFromPersonalInventory({commit}, data) {
        axios.post('api/removeFromInventory', data).then(() => {
            commit('removeFromPersonalInventory', data)
        })
    },

    async getDepositValues() {
        const response = await axios.get('api/getDepositsPricing')
        return response
    },

    removeFromInventory({commit}, data) {
        axios.post('api/removeFromInventory', data).then(() => {
            commit('removeFromPersonalInventory', data)
            commit('removeFromTotalInventory', data)
        })
    },

    issueInventory() {
      axios.get('api/issueInventory')
    },

    fetchTotalInventory({commit}) {
        return new Promise((resolve) => {
            axios.get('api/getCumulatedInventory').then((res) => {
                commit('setInventoryTotal', res.data)
                resolve(true)
            })
        })
    },

    fetchPersonalInventory({commit}) {
        return new Promise((resolve) => {
            axios.get('api/getInventory').then((res) => {
                commit('setInventoryPersonal', res.data)
                resolve(true)
            })
        })
    },

    getInventoryById(context, data) {
        const params = {
            id: data
        }
        return new Promise(resolve => {
            axios.post('api/getInventoryById', params).then((res) => {
                resolve(res)
            })
        })
    },

    fetchInventoryAvailable({commit}) {
        axios.get(('api/inventoryAvailable')).then((res) => {
            commit('setInventoryAvailable', res.data)
        })
    },

    downloadPDF(context, data) {
        const params = {
            id: data
        }
        return new Promise((resolve) => {
            axios.post('api/generateInventoryPDF', params, {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                responseType: 'blob',
            }).then((response) => {
                let file = new Blob([response.data])
                const url = window.URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Inventurliste.pdf');
                document.body.appendChild(link);
                link.click();
                resolve(true)
            })
        })
    }
}

export default actions
